import type { ActionApi } from '../../common/types.tsx';

export const removeCdm =
	(): ActionApi =>
	async ({ setState, getState }) => {
		// eslint-disable-next-line no-console
		console.log('removeCdm action called');

		const state = getState();

		// Add removing task
		setState({
			...state,
			cdm: {
				...state.cdm,
				tasks: [...state.cdm.tasks, 'deleteBundle'],
			},
		});

		// Wait 2 seconds
		await new Promise((resolve) => setTimeout(resolve, 2000));

		// Remove the task and add mock instantiation
		setState({
			...getState(),
			cdm: {
				instantiations: [],
				tasks: [],
			},
		});
	};
